import axios from "../axiosPlugin.js";

export const pdfTicketSaleDetailService = data => {
  return axios({
    url: "/api/report/pdfTicketSaleDetail",
    method: "get",
    data: { data },
  });
};

export const pdfShopSaleDetailService = data => {
  return axios({
    url: "/api/report/pdfShopSaleDetail",
    method: "get",
    data: { data },
  });
};